import { XLSX_MIME_TYPE } from "@repo/utils";
import type { GetAllInput } from "@types_def/common/filter.types";
import type { DeliveryPayment } from "@types_def/models/deliveryPayment.types";
import { navigateToBuffer } from "@/utils/download";

import { sendRequest } from "../../clients/axios";

export function downloadDeliveryInvoices(filters: GetAllInput<DeliveryPayment, "id">) {
  return sendRequest<GetAllInput<DeliveryPayment, "id">, { data: Iterable<number> }>(
    "post",
    "invoice/download-delivery-payments-xlsx",
    filters
  ).then((res) => {
    if (res.status === 201) {
      navigateToBuffer(new Uint8Array(res.data.data), XLSX_MIME_TYPE);
    }
  });
}
